import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { mdiRefresh, mdiRocketLaunch } from '@mdi/js';

import useAtualizacaoSistema from '@/hooks/useAtualizacaoSistema';
import Botao from './Botao';
import Icon from './Icon';

const TOAST_ID = 'sistema-atualizado';

/** Se o usuário fechar o aviso sem recarregar, lembramos de novo depois desse intervalo. */
const INTERVALO_LEMBRETE_MS = 10 * 60 * 1000;

/**
 * Avisa que saiu uma versão nova do sistema e oferece o recarregamento da página.
 * Não renderiza nada: só controla o ciclo de vida do toast.
 */
const AvisoAtualizacaoSistema = () => {
  const { atualizacaoDisponivel, recarregar } = useAtualizacaoSistema();

  useEffect(() => {
    if (!atualizacaoDisponivel) return;

    let ativo = true;
    let lembrete: ReturnType<typeof setTimeout> | undefined;

    const exibir = () => {
      if (!ativo) return;

      toast(
        <div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ marginRight: '8px', display: 'flex', alignItems: 'center', width: '32px', height: '32px', justifyContent: 'center' }}>
              <Icon path={mdiRocketLaunch} size={3} color="var(--tc-color-gray-400)" />
            </div>
            <div>
              <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                Nova versão disponível
              </div>
              <div style={{ marginBottom: '8px' }}>
                Salve o que estiver fazendo antes de atualizar.
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
            <Botao variant="primary" icon={mdiRefresh} onClick={recarregar}>
              Atualizar agora
            </Botao>
          </div>
        </div>
        ,
        {
          toastId: TOAST_ID,
          position: 'top-center',
          // type: 'info',
          // Fica na tela até o usuário atualizar ou fechar — não é aviso passageiro.
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          onClose: () => {
            if (ativo) lembrete = setTimeout(exibir, INTERVALO_LEMBRETE_MS);
          },
        },
      );
    };

    exibir();

    return () => {
      // `ativo` primeiro: o dismiss abaixo dispara o onClose, que não deve reagendar.
      ativo = false;
      if (lembrete) clearTimeout(lembrete);
      toast.dismiss(TOAST_ID);
    };
  }, [atualizacaoDisponivel, recarregar]);

  return null;
};

export default AvisoAtualizacaoSistema;
